import React from 'react';

import Button from '../../library/button/button';
import SearchButton, {
  SearchButtonGroup
} from '../search-button/search-button';

import { useCategories, useNavigateTo } from '../../shared/hooks/hooks';

import { trackAction } from '../../shared/utils/analytics/analytics';
import { isArrayWithLength } from '../../shared/utils/validators/validators';

import './choose-accessory-flow.scss';

interface ChooseAccessoryFlowProps {
  className?: string;
}

const ChooseAccessoryFlow = (props: ChooseAccessoryFlowProps) => {
  const { className } = props;
  const navigateTo = useNavigateTo();
  const { categoryData, isLoading } = useCategories({
    isTaxonomy: true,
    seoName: 'accessories'
  });

  return (
    <div className={className} styleName="container">
      {!isLoading && (
        <SearchButtonGroup styleName="search-button-group">
          {isArrayWithLength(categoryData) &&
            categoryData.map((v, idx) => (
              <SearchButton
                key={`${v.name}-${idx}`}
                label={v.name}
                onClick={() => {
                  navigateTo(`#/fitment/chooseAccessoryCategory/${v.seoName}`);
                }}
                styleName="search-button"
              >
                {v?.thumbnail?.url && (
                  <img alt={v.thumbnail.altText} src={v.thumbnail.url} />
                )}
              </SearchButton>
            ))}
        </SearchButtonGroup>
      )}

      <Button
        href="/fitmentresult/accessories"
        isSecondary
        onClick={() => trackAction('shop_modal_accessories_all')}
        styleName="view-all"
      >
        VIEW ALL
      </Button>
    </div>
  );
};

export default ChooseAccessoryFlow;
